import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

type PaginationActionSource = 'arrow' | 'btn';

interface PaginationViewModel {
  perPage: number;
  totalPages: number;
  currentPage: number;
  pages: number[];
  totalRecords: number;
}

interface PaginationSelectionEvent {
  pageIndex: number;
  source: PaginationActionSource;
}

@Component({
    selector: 'search-pagination',
    templateUrl: './search-pagination.component.html',
    styleUrls: ['./search-pagination.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchPaginationComponent {

  @Input() paginationData!: PaginationViewModel;
  @Output() paginationDataChange = new EventEmitter<PaginationViewModel>();
 
  @Output()
  selectedPage: EventEmitter<PaginationSelectionEvent> = new EventEmitter<PaginationSelectionEvent>();

  paginateTo(pageIndex: number, source: PaginationActionSource): void {
    this.selectedPage.emit({ pageIndex, source });
  }
}
